module.exports = "../images/rates-cad.jpg?v=5864f76";